import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from "vue-loading-overlay";
import {
  required,
  maxLength,
  minLength,
  numeric,
  maxValue,
  minValue
} from "vuelidate/lib/validators";
import axios from "axios";
import store from "@/store";
import ValidationService from '@/services/ValidationService';
import CONFIG from "@/assets/js/config.js";

export default {
  name: "HostelCreate",
  components: {
    MainLayout,
    Loading
  },
  mixins: [ValidationService],
  data() {
    return {
      campusId: store.state.user.campus_id,
      hostelData: {
        name: '',
        type: null,
        capacity: '',
        incharge_name: '',
        incharge_ph_no: '',
        incharge_teacher_id: null,
      },
      isTeacherIncharge: false,
      teacherList: [],
      submitted: false,
      disabled: false,
      isLoading: false,
      hostelTypes: CONFIG.HOSTEL_TYPE,
    };
  },

  validations: {
    hostelData: {
      name: {
        required,
        maxLength: maxLength(255)
      },
      type: {
        required,
      },
      capacity: {
        required,
        numeric,
        minValue: minValue(1),
        maxValue: maxValue(100),
      },
      incharge_name: {
        required,
        maxLength: maxLength(255)
      },
      incharge_ph_no: {
        numeric,
        minLength: minLength(8),
        maxLength: maxLength(11)
      }
    },
  },

  watch: {
    isTeacherIncharge(newValue) {
      this.submitted = false;
      if (newValue) {
        this.hostelData.incharge_name = '';
        this.getTeachers();
      } else {
        this.hostelData.incharge_teacher_id = null;
        this.hostelData.incharge_name = '';
        this.hostelData.incharge_ph_no = '';
      }
    },
    'hostelData.incharge_teacher_id': function (newVal) {
      if (newVal) {
        const selectedTeacher = this.teacherList.find(teacher => teacher.id === newVal);
        if (selectedTeacher) {
          this.hostelData.incharge_name = selectedTeacher.name;
          this.hostelData.incharge_ph_no = selectedTeacher.phone1;
        }
      } else {
        this.hostelData.incharge_name = '';
        this.hostelData.incharge_ph_no = '';
      }
    }
  },

  methods: {
    getTeachers() {
      this.isLoading = true;
      axios.get('hostel/teachers')
        .then(res => {
          this.teacherList = res.data;
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          console.error("Error fetching teachers:", error);
        });
    },

    create() {
      if (this.disabled) return;
      this.submitted = true;

      if (this.$v.$invalid) {
        this.validationErrors = {};
        return;
      }

      this.disabled = true;
      this.isLoading = true;
      const postData = { ...this.hostelData };
      axios.post('hostel/create', postData)
        .then(res => {
          if (res.data) {
            this.$notification.success("Hostel Created Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: 'hostelList'
            })
          } else {
            this.disabled = false;
            this.isLoading = false;
            this.$notification.error("Something went wrong", {
              timer: 3,
              position: "bottomCenter",
            });
          }
        }).catch((error) => {
          this.disabled = false;
          this.isLoading = false;
          this.printValidationError(error.response);
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
          }
        });
    },
  },
};
